// --- React
import { useMemo } from 'react';
// --- Redux
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
// --- Actions
import * as allActions from './actions';

export function useProductsActions() {
    const dispatch = useDispatch();

    return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
